import { render, staticRenderFns } from "./gs-shop-supplier-lookup.vue?vue&type=template&id=2cf344f2"
import script from "./gs-shop-supplier-lookup.vue?vue&type=script&lang=ts"
export * from "./gs-shop-supplier-lookup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports